let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gja4d")).then(() => parcelRequire('1NXaV'));